import {
  Action,
  AnyAction,
  configureStore,
  ThunkAction,
  isRejected,
  createListenerMiddleware,
} from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import userSlice from "../pages/UserPage/userSlice";
import feedbacksSlice from "../pages/FeedBacks/FeedBacksSlice";
import seasonRatesSlice from "../pages/PricingPage/SeasonRatesSlice";
import accommodationsSlice from "../pages/AccommodationsPage/accommodationsSlice";
import countriesSlice from "../features/countries/countriesSlice";
import errorSlice from "../features/errors/errorsSlice";
import reportsSlice from "../pages/ReportsPage/ReportsSlice";
import errorsReducer, {
  setApiError,
  setInputErrors,
} from "../features/errors/errorsSlice";
import statusToastReducer, {
  addStatusToast,
  statusToastSlice,
} from "../components/StatusToast/StatusToastSlice";
import accommodationSlice from "../pages/AccommodationsPage/accommodationSlice";
import identitySlice from "../features/identity/identitySlice";
import bookingsSlice from "../pages/BookingsPage/bookingsSlice";

// Redux toolkit listener middleware
const listenerMiddleware = createListenerMiddleware();
const submitActionTypes = ["add", "update", "insert", "save", "post"];

listenerMiddleware.startListening({
  matcher: isRejected,
  effect: async (action: AnyAction, listenerApi) => {
    if (
      submitActionTypes.some((type) => action.type.includes(type)) &&
      action.payload &&
      action.payload.status === 400
    ) {
      listenerApi.dispatch(setInputErrors(action.payload.errors));
      listenerApi.dispatch(
        addStatusToast({
          Title: "Virhe syötetyissä tiedoissa",
          Message: `Tarkista lomakkeen tiedot.`,
          IsFailed: true,
        }),
      );
    } else {
      listenerApi.dispatch(setApiError(action.payload));
    }
  },
});

const reducers = {
  accommodation: accommodationSlice,
  accommodations: accommodationsSlice,
  auth: authReducer,
  bookings: bookingsSlice,
  feedbacks: feedbacksSlice,
  identity: identitySlice,
  owner: userSlice,
  countries: countriesSlice,
  errors: errorSlice,
  statusToast: statusToastReducer,
  seasonRates: seasonRatesSlice,
  reports: reportsSlice,
};

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        //Ignore
        ignoredActions: [
          "bookings/getAccommodationBookings/fulfilled",
          "bookings/getAccommodationBookingsByIds/fulfilled",
        ],
        // Ignore these paths in the state
        ignoredPaths: ["payload.accommodationBookingItem", "bookings"],
      },
    }).prepend(listenerMiddleware.middleware),
  devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
